import {
  GOAL_DIRECTORY_ARCHIVED_PAGE,
  GOAL_DIRECTORY_ARCHIVED_PATH,
  GOAL_DIRECTORY_FOLLOWING_PAGE,
  GOAL_DIRECTORY_FOLLOWING_PATH,
  GOAL_DIRECTORY_PAGE,
  GOAL_DIRECTORY_PATH,
} from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const goalDirectoryRoute = createGlobalRoute({
  exact: true,
  name: GOAL_DIRECTORY_PAGE,
  path: GOAL_DIRECTORY_PATH,
  capabilities: ['goals_app:access'],
  subproduct: 'townsquare-goals',
  enableRestrictedFallback: true,
});

export const goalNoWorkspaceDirectoryRoute = createGlobalRoute({
  exact: true,
  name: GOAL_DIRECTORY_PAGE,
  path: GOAL_DIRECTORY_PATH,
  subproduct: 'townsquare-goals',
});

export const goalDirectoryFollowingRoute = createGlobalRoute({
  exact: true,
  name: GOAL_DIRECTORY_FOLLOWING_PAGE,
  path: GOAL_DIRECTORY_FOLLOWING_PATH,
  capabilities: ['goals_app:access'],
  subproduct: 'townsquare-goals',
  enableRestrictedFallback: true,
});

export const goalDirectoryArchivedRoute = createGlobalRoute({
  exact: true,
  name: GOAL_DIRECTORY_ARCHIVED_PAGE,
  path: GOAL_DIRECTORY_ARCHIVED_PATH,
  capabilities: ['goals_app:access'],
  subproduct: 'townsquare-goals',
  enableRestrictedFallback: true,
});
